<!-- NewYorkPreschoolBilling.vue -->
<script setup lang="ts">
import _ from 'lodash';
import { initPinia } from "../../../lib/PiniaMgr";
import { useListStore } from "../../../lib/Stores/ListStore";
import { LayoutOrientation } from '../../../Enums/UiEnums';
import TextInput from '../../../components/TextInput.vue';
import SimpleFlexTable from '../../../components/Table/SimpleFlexTable.vue';
import SimpleFlexTableTitledRow from '../../../components/Table/SimpleFlexTableTitledRow.vue';
import GenericSearch from '../../../components/Search/GenericSearch.vue';
import ListSelect from '../../../components/Select/ListSelect.vue';
import RadioButtonInput from '../../../components/RadioButtonInput.vue';
import { IPatientDecodeValue } from '../../../lib/Models/Patient/IPatientDecodeValue';

    const props = defineProps<{
        patientData: IPatientDecodeValue
    }>();

    // Initialize list store data
    const listStore = useListStore(initPinia());    
    listStore.getNyPreschoolBilling_CPSEDistricts();

    const emits = defineEmits(["update:patientData"]);
    function emitPatientData()
    {
        emits("update:patientData", props.patientData);
    }
</script>

<style scoped>
    .TitleColWidth { flex-basis: 12em; flex-grow: 0; }
</style>

<template>
    <template v-if="patientData">
        <SimpleFlexTable :columnClasses='["simple-cell TitleColWidth", "simple-cell"]'>
            <SimpleFlexTableTitledRow>
                <template #Title>STAC Id</template>
                <TextInput v-model:textValue="patientData.stacId" @update:modelValue="emitPatientData" :maxLength="50" />
            </SimpleFlexTableTitledRow>

            <SimpleFlexTableTitledRow>
                <template #Title>CPSE District</template>
                <ListSelect
                    v-model="patientData.cpseDistrict"
                    @update:modelValue="emitPatientData"
                    :options="listStore.nyPreschoolBilling_CPSEDistricts" />
            </SimpleFlexTableTitledRow>

            <SimpleFlexTableTitledRow>
                <template #Title>County of Residence</template>
                <GenericSearch searchId="30.0" v-model="patientData.countyResidence" @update:modelValue="emitPatientData" />
            </SimpleFlexTableTitledRow>

            <SimpleFlexTableTitledRow>
                <template #Title>Foster Care County</template>
                <GenericSearch searchId="30.0" v-model="patientData.countyFoster" @update:modelValue="emitPatientData" />
            </SimpleFlexTableTitledRow>

            <SimpleFlexTableTitledRow>
                <template #Title>Disability</template>
                <RadioButtonInput v-model="patientData.disabilityId" value="ND" :layout="LayoutOrientation.Horz" @update:modelValue="emitPatientData">
                    Non-disabled
                </RadioButtonInput>
                <RadioButtonInput v-model="patientData.disabilityId" value="PD" :layout="LayoutOrientation.Horz" @update:modelValue="emitPatientData">
                    Preschooler with disability
                </RadioButtonInput>
            </SimpleFlexTableTitledRow>
        
            
        </SimpleFlexTable>
    </template>
</template>